// extracted by mini-css-extract-plugin
export default {"label":"FormInputNumeric_label__NHl5v","labelWeight":"FormInputNumeric_labelWeight__tacGk"};